<template>
  <div class="w-full h-full p-6">
    <BasicInformation />
    <TransactionHistory />
    <CurrentActivity />
  </div>
</template>

<script>
import BasicInformation from './includes/Customer/BasicInformation';
import TransactionHistory from './includes/Customer/TransactionHistory';
import CurrentActivity from './includes/Customer/CurrentActivity';

export default {
  name: 'Customer',
  components: {
    BasicInformation,
    TransactionHistory,
    CurrentActivity,
  },
};
</script>

<style scoped>

</style>
